import { render, staticRenderFns } from "./strata.vue?vue&type=template&id=36e7d4b9"
import script from "./strata.vue?vue&type=script&lang=js"
export * from "./strata.vue?vue&type=script&lang=js"
import style0 from "./strata.vue?vue&type=style&index=0&id=36e7d4b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports